import { Dialog, DialogContent, DialogTitle, Popover, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { LoadOrganizations } from '../../actions';
import setToast from '../../helpers/toaster.helper';
import { OrganizationModel } from '../../models/organization.model';
import { OrganizationService } from '../../services/OrganizationService';
import { UtilityService } from '../../services/UtilityService';
import ConfirmDialog from '../shared/confirm-dialog.component';
import { ActionLabels, appNote, buttonLabels, emptyLabels, pageTitles, ToasterTexts } from '../shared/constants';
import SubpageHeaderComponent from '../shared/subpage-header.component';
import { ToasterType } from '../shared/toaster/toaster.model';
import OrgSettings from './org-settings.component';
import ViewOrganization from './organization-view.component';
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { AppRoutes } from '../routes/route.path';
import PageHeaderComponent from '../shared/page-header.component';
import GridComponent from '../shared/grid'
import { ColDef, ColumnApi, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { ValueFormatterParams, } from 'ag-grid-community'
import { dateComparator } from "../shared/grid/grid.services";
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { GridStatusLabelVariant } from '../shared/constants';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { AddOrgIcon, CancelIcon, DisableIcon, EditIcon, EnableIcon, SettingsIcon } from '../../icon';
import { CustomFilterCategory } from "../shared/filters/filter.model";
import _ from 'lodash';
import FilterComponent from '../shared/filters/filter.component';
import { HeaderTemplate } from "../shared/grid/grid.services";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useDispatch } from 'react-redux';


interface IProps {
}


const Organization = (props: IProps) => {
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const LoadingOrganizations: boolean = useSelector(selector.loadingOrganizations)
    const Organizations: OrganizationModel[] = useSelector(selector.organizations)
    const [DialogAction, setDialogAction] = useState<string>("")
    const [show, setShow] = useState<boolean>(false)
    const [Text, setText] = useState<string>("")
    const [ClickRowId, setClickRowId] = useState<string>("")
    const [ButtonName, setButtonName] = useState<string>("")
    const [MobileMenu, setMobileMenu] = useState<boolean>(false)
    const [EditOrgainzation, setEditOrgainzation] = useState<OrganizationModel>(undefined)
    const [SelectedOrganizationId, setSelectedOrganizationId] = useState<string>("")
    const [viewOrganization, setViewOrganization] = useState<boolean>(false)
    const [ShowSettings, setShowSettings] = useState<boolean>(false)
    const [OrgId, setOrgId] = useState<string>("")
    const [IsEdit, setIsEdit] = useState<boolean>(false)
    const [IsDelete, setIsDelete] = useState<boolean>(false)
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [gridApi, setGridApi] = useState<any>(null)
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [anchorEl, setAnchorEl] = useState<Element | null>(null)
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false)
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [appliedfilters, setappliedfilters] = useState<OrganizationModel[]>([]);
    const [selectedFilterOptions, setSelectedFilterOptions] = useState<number | null>();
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);

    const addOrg = () => {
        setViewOrganization(true);
        setIsEdit(false);
    }

    const closeViewOrg = () => {
        setViewOrganization(false);
        setIsEdit(false);
        setSelectedOrganizationId("")
    }
    const searchOrganizations = (e: any) => {
        gridApi?.setQuickFilter(e.target.value)
    }

    useEffect(() => {
        if (Organizations?.length === 0 && !LoadingOrganizations) {
            refreshData();
        }
        LoadOrganizations(dispatch);
    }, []);

    useEffect(() => {
        setHeaderTitle(pageTitles.Organizations);
        setHeaderCount(Organizations?.length || 0)
        setRefreshHandler(gridRefresh)
        return setHeaderTitle
    }, [gridApi, columnApi])

    const refreshData = () => {
        LoadOrganizations(dispatch);
    };

    const gridRefresh = () => {
        resetFilters()
        refreshData();
        LoadOrganizations(dispatch);
        if (!!columnApi) {
            columnApi?.resetColumnState()
        }
        if (!!gridApi) {
            gridApi?.refreshCells({ force: true })
        }
        gridApi?.deselectAll();
    }

    const OrgColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Organization Name",
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            minWidth: 200,
        },

        {
            field: "PhoneNumberCount",
            headerName: "Phone Number",
            autoHeight: true,
            cellRenderer: (params: ICellRendererParams) => {
                const State = { OrganizationID: params.data.ID }
                return <Link to={AppRoutes.PHONE_NUMBERS} state={State} className="color-vigenary-light">{params.data.PhoneNumberCount}</Link>
            },
        },

        {
            field: "users",
            headerName: "Users",
            autoHeight: true,
            cellRenderer: (params: ICellRendererParams) => {
                const State = { OrganizationID: params.data.ID }
                return <Link to={AppRoutes.USERS} state={State} className="color-vigenary-light">{params.data.UserCount}</Link>
            },
        },

        {
            field: "isDeleted",
            headerName: "Status",
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.IsDeleted ? "Disable" : "Enable";
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.IsDeleted ? "Disable" : "Enable";
                    const variant = params.data.IsDeleted ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Active;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
            suppressSizeToFit: true,
            minWidth: 100,
            width: 100,
            maxWidth: 100
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.value).toString()
            },
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime).toString()
            },
            sort: 'desc',
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            minWidth: 150,
            width: 150,
            maxWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice,
        },
    ]

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const getMenuActions = (data: OrganizationModel) => {
        return [
            {
                Name: (data as OrganizationModel)?.IsDeleted ? ActionLabels.ENABLE : ActionLabels.DISABLE,
                Icon: (data as OrganizationModel)?.IsDeleted ? EnableIcon : DisableIcon,
                OnClick: () => { openConfirmDialog((data as OrganizationModel)?.ID, (data as OrganizationModel)?.IsDeleted) },
            },
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => {
                    setSelectedOrganizationId((data as OrganizationModel)?.ID);
                    setViewOrganization(true);
                    setIsEdit(true);
                    setMobileMenu(false);
                },
            },
            {
                Name: ActionLabels.SETTINGS,
                Icon: SettingsIcon,
                OnClick: () => {
                    setShowSettings(true);
                    setOrgId((data as OrganizationModel)?.ID);
                    setMobileMenu(false);
                }
            }
        ]
    }

    const resetFilters = () => {
        setFilterOptions([])
        setappliedfilters([])
        setSelectedFilterOptions(null)
        setSelectedFilterTypes([])
        initialFilterOptions()
    }


    const openConfirmDialog = (rowId: string, IsDeleted: boolean) => {
        let text = IsDeleted ? appNote.ORG_ENABLE : appNote.ORG_DISABLE;
        let btnName = IsDeleted ? ActionLabels.ENABLE : ActionLabels.DISABLE;
        setShow(true);
        setClickRowId(rowId);
        setText(text);
        setDialogAction(btnName);
        setButtonName(btnName);
        setMobileMenu(false);
        setIsDelete(IsDeleted);
        setIsLoading(false);
    }

    const closeConfirmDialog = (isConfim: boolean) => {
        let Name = Organizations?.find((x: OrganizationModel) => x.ID === ClickRowId)?.Name || ''
        if (!!isConfim) {
            setIsLoading(true);
            OrganizationService.deleteOrganizations(ClickRowId).then(res => {
                resetFilters()
                setShow(false);
                setClickRowId(null);
                setIsLoading(false);
                setToast(IsDelete ? ToasterTexts.ORGANIZATION_ENABLE_SUCCESS.replace('<Name>', Name) : ToasterTexts.ORGANIZATION_DISABLE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS);
                LoadOrganizations(dispatch);
                refreshData();
            });
        } else {
            setShow(false);
            setClickRowId(null);
            setIsLoading(false);
        }
    };

    const closeSettings = () => {
        setShowSettings(false);
        setViewOrganization(false);
        setOrgId("");
    }

    const handleRowClick = (row: OrganizationModel) => {
        if (IsMobileDevice) {
            setMobileMenu(true);
            setEditOrgainzation(row);
        }
    }

    const CloseMobileMenu = () => {
        setMobileMenu(false);
        setEditOrgainzation(undefined);

    }

    const AdminOrganizations = Organizations?.filter(x => x.Name !== "Admin")

    const getGridTitle = () => {

        if (Organizations?.length === 1) {
            return "1 Organization"
        }
        else {
            return AdminOrganizations?.length + " " + pageTitles.Organizations
        }
    }

    const initialFilterOptions = () => {
        const filterData: CustomFilterCategory[] = [
            {
                Id: 1,
                Title: "Status",
                IsSelectedAll: false,
                Options: _(Organizations).map((row) => {
                    return {
                        Key: "IsDeleted",
                        Id: row.ID,
                        Label: row.IsDeleted === true ? "Disable" : row.IsDeleted === false ? "Enable" : null,
                        Value: row.IsDeleted,
                        IsSelected: false,
                    }
                })
                    .unionBy("Label")
                    .value(),
            }
        ]
        setFilterOptions(filterData)

    }

    useEffect(() => {
        initialFilterOptions()
        setHeaderCount(Organizations?.length || 0)
    }, [Organizations])

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (IsMobileDevice) {
            setShowFilterOptions(true);
        }
        else {
            setAnchorEl(event.currentTarget)
        }
    }

    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };


    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => refreshData());


    return (

        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            {(viewOrganization || ShowSettings) && IsMobileDevice && <SubpageHeaderComponent HeaderText={`${ShowSettings ? "Organization Settings" :
                IsEdit ? "Edit Organization" : "Add Organization"}`} PreviousPage={ShowSettings ?
                    closeSettings : closeViewOrg} />
            }
            {viewOrganization && IsMobileDevice ?
                <ViewOrganization SelectedOrganizationId={SelectedOrganizationId}
                    ViewOrganization={viewOrganization}
                    handleClose={closeViewOrg}
                    IsEdit={IsEdit} />
                :
                <>
                    {ShowSettings && IsMobileDevice ?
                        <OrgSettings
                            onClose={closeSettings}
                            settings={ShowSettings}
                            OrgId={OrgId}
                        />
                        :
                        <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} >
                            <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                                <>
                                    <PageHeaderComponent
                                        Reload={() => LoadOrganizations(dispatch)}
                                        Actions={[{
                                            OnClick: () => addOrg(),
                                            ButtonLabel: buttonLabels.ADD_ORGANIZATION,
                                            Icon: AddOrgIcon,
                                            Variant: "primary-btn",
                                        }]}
                                        PlaceHolder={IsMobileDevice ? "Search..." : "Find an Organization..."}
                                        onSearch={searchOrganizations}
                                        GridTitle={""}
                                        Count={AdminOrganizations.length}
                                        ShowFilterIcon={true}
                                        IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                                        HandleFilter={handleClickFilter}
                                    />

                                    <GridComponent
                                        ColumnDefs={OrgColoumnDefs}
                                        RowData={Organizations}
                                        OnGridReady={onGridReady}
                                        OnGridRowClick={handleRowClick}
                                        IsPaginationEnabled={!IsMobileDevice}
                                        EmptyLabel={emptyLabels.ORGANIZATION}
                                        LockVisible={IsMobileDevice}
                                        filterOptions={filterOptions}
                                        IsFilterPresent={true}
                                        gridApi={gridApi}
                                    />


                                    {
                                        viewOrganization && !IsMobileDevice && <ViewOrganization SelectedOrganizationId={SelectedOrganizationId}
                                            ViewOrganization={viewOrganization}
                                            handleClose={closeViewOrg}
                                            IsEdit={IsEdit}
                                        />
                                    }

                                    {
                                        show && <ConfirmDialog
                                            onClose={closeConfirmDialog}
                                            Show={show}
                                            Text={Text}
                                            ButtonName={ButtonName}
                                            IsMobileDevice={IsMobileDevice}
                                            Loading={IsLoading}
                                        />
                                    }

                                    {
                                        ShowSettings && !IsMobileDevice &&
                                        <OrgSettings
                                            onClose={closeSettings}
                                            settings={ShowSettings}
                                            OrgId={OrgId}
                                        />
                                    }

                                    {
                                        MobileMenu &&
                                        <Dialog
                                            fullWidth
                                            onClose={CloseMobileMenu}
                                            aria-labelledby="responsive-dialog-title"
                                            open={true}
                                            BackdropProps={{ style: { backgroundColor: "transparent" } }}
                                            classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
                                        >
                                            <DialogTitle className="dialog-header">
                                                <div className="h1 color-display-title d-flex" id="customized-dialog-title">
                                                    {EditOrgainzation?.Name}
                                                    <Tooltip title='Close' placement='bottom'><span className={"ml-auto"}><CancelIcon className={"c-pointer"} onClick={CloseMobileMenu} /></span></Tooltip>
                                                </div>
                                            </DialogTitle>
                                            <DialogContent className={"mln-1 o-hidden pt-0"} >
                                                <MenuItemRenderer MenuData={getMenuActions(EditOrgainzation)} OnClick={CloseMobileMenu} />
                                            </DialogContent>
                                        </Dialog>
                                    }
                                    {
                                        !IsMobileDevice && Boolean(anchorEl) &&

                                        <Popover
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            onClose={handleCloseFilter}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
                                        // BackdropProps={{
                                        //     invisible: true,
                                        //     onClick: (event) => event.stopPropagation(),
                                        // }}
                                        >
                                            <FilterComponent
                                                Filters={filterOptions}
                                                HandleApplyFilters={handleApplyFilters}
                                                OnClose={handleCloseFilter}
                                            />
                                        </Popover>
                                    }
                                </>
                            </div>
                        </PullToRefresh>}
                </>}
        </div>
    )
}

export default Organization
